module.exports = __webpack_public_path__ + "img/in-hub-logo-partially.ab53d80f.svg";